<template>
  <div class="input-wrapper">

    <label
      for="cityName"
      class="input-wrapper__label"
    >{{ ($t('companyFormData.city')) }} *</label>

    <input
      id="cityName"
      name="cityName"
      autocomplete="off"
      required
      type="text"
      maxlength="64"
      placeholder="Aachen"
      class="input-wrapper__input"
      :value="cityName"
      :class="{ 'invalid-input': errorObj.cityName }"
      @input="(e) => {debouncedInputValidate($emit('update:modelValue', e.target.value)); cityName=e.target.value}"
      @blur="validateOnBlur"
      @keydown.tab="handleTabKey"
    />

    <div
        v-if="errorObj.cityName"
        class="input-wrapper__label input-wrapper__label--error">
        {{ $t(errorObj.cityName) }}
    </div>

  </div>
</template>

<script>
import { ref } from 'vue'
import useSignup from '@/composables/useSignup'
import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'
import useTabKeyValidation from '@/composables/useTabKeyValidation'

export default {
  setup () {
    const { t } = useI18n()
    // refs/reactive data
    const cityName = ref('')

    const inputValidate = () => {
      cityNameValidate('cityName', cityName.value)
    }

    const { validateOnBlur } = useTabKeyValidation(inputValidate)

    // return values 'errorObj, nameFieldsValidate' from useSignup
    const { cityNameValidate, errorObj } = useSignup(t)

    const debouncedInputValidate = debounce(inputValidate, 500)

    return { cityName, debouncedInputValidate, inputValidate, validateOnBlur, t, errorObj }
  }
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  position: relative;
  &__input {
    @include input;

    &:focus {
        @include input-focus;
    }
  }
  &__label {
    text-align: left;

    @include input-label;

    &--error {
      @include error-message;
      &::after {
        content: '';
        width: var(--spacing-m);
        height: var(--spacing-m);
        position: absolute;
        top: 36px;
        right: 12px;
        background-image: url('../assets/images/exclamation-circle.svg');
        background-position: center center;
        background-repeat: no-repeat;
        z-index: -1;

        @include respond-to('small') {
          top: 40px;
        }
      }
    }
  }
  .invalid-input {
    @include invalid-input;
  }

  @include shake;
}
</style>
